import React, { useEffect, useState } from 'react';
import { ReactComponent as EaseShopping } from '../../assets/icons/EaseShopping.svg';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const EmptyCartStyles = `
.icon-hidden {
  opacity: 0;
  transform: translateY(20px) rotate(-5deg);
}

.icon-visible {
  opacity: 1;
  transform: translateY(0) rotate(0);
  transition: opacity 0.8s ease, transform 0.8s ease;
}

.title-hidden, .subtitle-hidden {
  opacity: 0;
  transform: translateY(20px);
}

.title-visible, .subtitle-visible {
  opacity: 1;
  transform: translateY(0);
}

.button-hidden {
  opacity: 0;
  transform: scale(0.9);
}

.button-visible {
  opacity: 1;
  transform: scale(1);
}

/* Float animation for the icon */
@keyframes float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

.animate-float {
  animation: float 3s ease-in-out infinite;
}
`;

function EmptyCart() {
	const { t } = useTranslation();
	const [isVisible, setIsVisible] = useState(false);

	useEffect(() => {
		// Trigger animations after component mounts
		setIsVisible(true);
	}, []);

	return (
		<>
			<style>{EmptyCartStyles}</style>
			<div className={`w-full flex flex-col items-center mt-[16px] mb-[230px] transition-opacity duration-500 ease-out ${isVisible ? 'opacity-100' : 'opacity-0'}`}>
				<div className="w-[430px] flex flex-col items-center">
					<div className={`animate-float ${isVisible ? 'icon-visible' : 'icon-hidden'}`}>
						<EaseShopping width={253} height={253} title="Empty cart" />
					</div>

					<h2 className={`text-[30px] leading-[36px] font-bold text-black mt-10 text-center px-5 transition-all duration-500 delay-300 ease-out ${isVisible ? 'title-visible' : 'title-hidden'}`}>{t('There is still space in your cart')}</h2>

					<h3 className={`text-[16px] leading-[24px] font-normal text-black text-center mt-5 transition-all duration-500 delay-500 ease-out ${isVisible ? 'subtitle-visible' : 'subtitle-hidden'}`}>{t('Browse our products to start filling it now.')}</h3>

					<Link
						to={'/'}
						className={`w-full max-w-[343px] h-[44px] flex items-center justify-center rounded-[30px] bg-laykaDarkPurple text-[16px] text-white font-bold mt-[30px] uppercase transition-all duration-500 delay-700 ease-out transform hover:bg-purple-700 hover:scale-105 active:scale-95 ${
							isVisible ? 'button-visible' : 'button-hidden'
						}`}
					>
						{t('Explore products')}
					</Link>
				</div>
			</div>
		</>
	);
}

export default EmptyCart;
